module.exports = __webpack_public_path__ + "76df6e401d15e07efeed16128130e4f2.svg";